import { Controller } from "@hotwired/stimulus"

// カテゴリナビ: PCサイドバーはアコーディオン、モバイルはドロップダウン
export default class extends Controller {
  static targets = ["accordionButton", "accordionPanel", "dropdownButton", "dropdownMenu"]

  connect() {
    // 初期化: サイドバーのアコーディオンを閉じる
    this.accordionPanelTargets.forEach(panel => {
      panel.classList.add("hidden");
    });
  }

  toggleAccordion(event) {
    const button = event.currentTarget;
    const panel = button.nextElementSibling;
    if (panel.classList.contains("hidden")) {
      panel.classList.remove("hidden");
      button.setAttribute("aria-expanded", "true");
    } else {
      panel.classList.add("hidden");
      button.setAttribute("aria-expanded", "false");
    }
  }

  toggleDropdown(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const menu = button.nextElementSibling;
    if (menu.classList.contains("hidden")) {
      menu.classList.remove("hidden");
      button.setAttribute("aria-expanded", "true");
    } else {
      menu.classList.add("hidden");
      button.setAttribute("aria-expanded", "false");
    }
  }
}
